import { useMutation } from "@apollo/client/react";import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import { useStepSave } from "../../../../hooks/useStepSave";
import SAVE_VISITA_TELE_ENFERMERIA_CP, { adaptAddVisitaTeleEnfermeriaCPInput } from "../../../../../../data/graphQL/mutations/Visitas/saveControlSintomas";

import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function PsicoemocionalEducacion({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_VISITA_TELE_ENFERMERIA_CP);

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  const formattedGroups = useMemo(() => {
    return groups.map((group) => {
      return {
        ...group,
        inputs: group.inputs.map((input) => {
          const newInput = { ...input };

          if (esUrgencia) newInput.required = false;

          if (readOnly) newInput.disabled = true;

          return newInput;
        })
      };
    });
  }, [readOnly, esUrgencia]);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedGroups, formData });

    const { data } = await save({ variables: { input: adaptAddVisitaTeleEnfermeriaCPInput(formData) } });

    const idTeleEnfermeriaCP = data?.saveVisitaTeleEnfermeriaCP?.idTeleEnfermeriaCP;
    if (!idTeleEnfermeriaCP) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData
    }));
  });

  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'psicoemocionalEducacion',
      stepName: 'Psicoemocional y educación',
      formattedGroups
    });
  }, [onExposeFormatted, formattedGroups]);


  return (
    <>
      {formattedGroups.map((group, idx) =>
      <CardBox key={idx} title={group.title}>
          <Grid container spacing={2}>
            {group.inputs.map((input) =>
          <Grid size={{ xs: 12 }} key={input.name}>
                <RenderInputByTypeMobile
              input={input}
              value={formData[input.name]}
              handleChange={handleChange} />
            
              </Grid>
          )}
          </Grid>
        </CardBox>
      )}
    </>);

}

const groups = [
{
  title: "Psicoemocional",
  inputs: [
  {
    name: "sentimiento",
    displayName: "¿Cómo se encuentra usted hoy?",
    type: "long_string",
    maxLength: 250,
    required: true
  },
  {
    name: "preocupacion",
    displayName: "¿Hay algo que lo preocupe?",
    type: "long_string",
    maxLength: 250,
    required: true
  }]

},
{
  title: "Educación",
  inputs: [
  {
    name: "repasoIndicacion",
    displayName: "¿Podemos repasar sus indicaciones?",
    type: "long_string",
    maxLength: 250,
    required: true
  },
  {
    name: "ampliarConcepto",
    displayName: "¿Le gustaría ampliar / revisar algún concepto de lo indicado?",
    type: "long_string",
    maxLength: 250,
    required: true
  }]

}];